import type { ComponentProps, PropsWithChildren } from 'react';
import classes from './EntityFormLayout.module.scss';
import cardClasses from '@/styles/entity-details.module.scss';

/** Отображает заголовок и содержимое формы сущности. */
export const EntityFormLayout = ({ title, children }: PropsWithChildren<{ title: string }>) => (
    <div className={cardClasses.detailsCard}>
        <h1 className={classes.title}>{title}</h1>
        {children}
    </div>
);

/** Располагает разделы формы и действия с общими вертикальными интервалами. */
export const EntityForm = ({ className, children, ...props }: ComponentProps<'form'>) => (
    <form
        {...props}
        className={[classes.form, className].filter(Boolean).join(' ')}
    >
        {children}
    </form>
);

/** Группирует поля формы в именованный раздел. */
export const EntityFormSection = (
    {
        title,
        id,
        children,
    }: PropsWithChildren<{ title: string; id: string }>
) => (
    <section
        className={classes.section}
        aria-labelledby={id}
    >
        <h2
            id={id}
            className={classes.sectionTitle}
        >
            {title}
        </h2>
        {children}
    </section>
);

/** Располагает поля формы в адаптивной сетке. */
export const EntityFormFields = ({ children }: PropsWithChildren) => (
    <div className={classes.fields}>{children}</div>
);

/** Располагает содержимое раздела формы с едиными вертикальными интервалами. */
export const EntityFormStack = ({ children }: PropsWithChildren) => (
    <div className={classes.stack}>{children}</div>
);
